"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Winner = function Winner() {
  return _react2.default.createElement(
    "g",
    { id: "winner" },
    _react2.default.createElement("path", {
      d: "M447.638 112.11c0 28.56-24.11 52.397-55.948 57.688V80.453h55.948v31.658zm-394.348 0V80.454h55.96V169.8c-31.857-5.287-55.96-29.13-55.96-57.688zm225.84-7.387l48.642 12.17-30.917 34.114.64 19.907.75 23.124-47.784-14.422-47.77 14.422.75-23.124.64-19.907-30.92-34.114 48.647-12.17 19.59-24.27 9.068-11.234 9.074 11.234 19.595 24.265zm221.798 7.388V35.22H391.69V0H109.238v35.215H0v76.896c0 56.28 52.95 102.157 118.77 103.886 17.07 37.53 55.695 66.14 102.922 74.525v37.377c-37.368 9.37-65.908 36.455-72.14 69.687h-38.3v50.77h278.43V397.58h-38.3c-6.232-33.228-34.767-60.313-72.14-69.688v-37.38c47.227-8.384 85.856-36.994 102.923-74.525 65.82-1.72 118.763-47.6 118.763-103.876z",
      id: "Shape"
    })
  );
};

exports.default = Winner;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Winner.js
// module id = 3009
// module chunks = 4